<template>
    <div>
        <b-modal 
        id="create-task-modal"
        v-model="create" 
        @hidden="resetModal"
        title="Add Task"
        @ok="handleOk"

        >
            <b-container fluid>
            <Loading v-if="loading"/>
            
                <b-form @submit.stop.prevent ="onSubmit" >
        
                <b-form-group
                    id="input-group-1"
                    label="Task Name:"
                    label-for="input-1"
                
                >
                    <b-form-input
                    id="input-1"
                    v-model="form.name"
                    type="text"
                    placeholder="Enter task name"
                    required
                    ></b-form-input>
                    <div class="text-danger text-center">
                        <span v-if="!$v.form.name.required && $v.form.name.$anyDirty">Task name is required</span>
                    </div>
                </b-form-group>

                <b-form-group
                    id="input-group-1"
                    label="Recomended Time:"
                    label-for="input-1"
                
                >
                    <b-form-input
                    id="input-1"
                    v-model="form.time"
                    type="time"
                    required
                    ></b-form-input>
                    <div class="text-danger text-center">
                        <span v-if="!$v.form.time.required && $v.form.time.$anyDirty">Recomended time is required</span>
                    </div>
                </b-form-group>

                <b-form-group
                    id="input-group-1"
                    label="Direction Of Task:"
                    label-for="input-1"
                
                >
                    <b-form-select v-model="form.direction" :options="options" required ></b-form-select>
                    <div class="text-danger text-center">
                        <span v-if="!$v.form.direction.required && $v.form.direction.$anyDirty">Direction is required</span>
                    </div>
                </b-form-group>

                </b-form>
            </b-container>
        </b-modal>
  </div>
</template>
<script>
import Loading from '../../Loading'
import { required } from 'vuelidate/lib/validators'

export default {

    components:{
      Loading
    },
    data(){
        return{

          form:{
            name:'',
            time:'',
            direction:'',
          },
          loading:false,
          create:false,
          options: [
       
          { value: 'IN', text: 'ARRIVING AT OFFICE' },
          { value: 'OUT', text: 'LEAVING THE OFFICE' }
        ]

        }
    },
    validations () {
        return {
            form: { 
                name: { required },
                time: { required },
                direction: { required }
            }
        
        }
    },
    methods:{
        resetModal() {
           this.form.name = ''
           this.form.time = ''            
           this.form.direction = ''            
        },

        handleOk(bvModalEvt){

            bvModalEvt.preventDefault()
            this.handleSubmit()

        },

        handleShow(){

          this.create = !this.create

        },

        handleSubmit(){
         this.$v.$touch();
         if(this.$v.$error) return

         this.loading = true
         fetch(`${process.env.VUE_APP_APIURL}/attendance/task`, 
            {
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                     'authorization':this.$store.state.token
                },
                body : JSON.stringify({ "tasks":this.$store.state.tasks ,"name":this.form.name , "time":this.form.time , "direction":this.form.direction ,"id": this.$store.state.user['corporateadmin.CorporateID']})
            })
            .then(response => response.json())
            .then(data => {   

                this.$store.dispatch("getTasks") 
                this.$emit('changeMsg', 'Task created')
               

                setTimeout(() => {   
                  this.loading=false
                  this.$bvModal.hide('create-task-modal')
                 
                }, 2000);            
            })
            .catch(err => {
                setTimeout(() => {
                    this.loading=false
                    this.$emit('changeError', 'Something went wrong.')
                }, 2000);
            });

           


        },
    }
};
</script>
